import http from "@/http-common"

class ReportDataService {
    report_xlsx(data) {
        return http.post("report_xlsx", data, { responseType: "blob" })
    }
}

export default new ReportDataService()